import { useLocation } from 'react-router';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import stringToDate from '../../../function/stringToDate';
import useValidPolozkyCiselnik from './useValidPolozkyCiselnik';
import { toKodArray } from '../../../function/toKodArray';
import { mapSearchText } from '../../../function/mapSearchText';

interface ReturnType {
  initialFilterLoading: boolean;
  initialFilter?: NavrhAktuEuFilter;
}

export default (): ReturnType => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const typAktuKodArray = toKodArray(search.get('typAktu'));
  const instituciaKodArray = toKodArray(search.get('institucia'));
  const polozkyKody = [...typAktuKodArray, ...instituciaKodArray];

  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useValidPolozkyCiselnik([], [], true, polozkyKody, polozkyKody.length > 0);

  return {
    initialFilter: polozkyCiselnik ? {
      hladanyVyraz: mapSearchText(search.get('hladanyVyraz')),
      cisloLegislativnehoMaterialu: mapSearchText(search.get('cisloLegislativnehoMaterialu')),
      identifikatorAktu: mapSearchText(search.get('identifikatorAktu')),
      nazovLegislativnehoMaterialu: mapSearchText(search.get('nazovLegislativnehoMaterialu')),
      nazovAktu: mapSearchText(search.get('nazovAktu')),
      type: polozkyCiselnik.find(polozka => polozka.kod && typAktuKodArray.includes(polozka.kod)),
      institucia: polozkyCiselnik.find(polozka => polozka.kod && instituciaKodArray.includes(polozka.kod)),
      medziinstitucionalnyKod: mapSearchText(search.get('medziinstitucionalnyKod')),
      datumPrijatiaAktuOd: stringToDate(search.get('datumPrijatiaAktuOd')),
      datumPrijatiaAktuDo: stringToDate(search.get('datumPrijatiaAktuDo')),
    } : undefined,
    initialFilterLoading: polozkyCiselnikStatus.loading,
  };
};
